import styled from 'styled-components';

export const HorizontalListStyled = styled.div<{
  padding: number;
  maxLength?: number;
  length: number;
  isScrollable?: boolean;
  paddingBottom?: number;
}>`
  gap: ${(props) => props.padding}px;
  padding-bottom: ${(props) =>
    props.paddingBottom ? `${props.paddingBottom}px` : ''};
  display: flex;
  ${(props) =>
    props.isScrollable
      ? `
    overflow-x: auto;
  `
      : ''}
  ${(props) =>
    props.maxLength && !props.isScrollable
      ? `
      display:grid;
      grid-template-columns: repeat( ${props.maxLength}, 1fr);
      `
      : ''}
`;
